// Backend messages remain unchanged; display their meaning in the selected UI language.
const detailKeys = {
  "Zahtjev nije dopušten.": "forbidden",
  "Zahtjev nije valjan.": "validation",
  "Veza je istekla. Pokušajte ponovno poslati poruku.": "sessionExpired",
  "Sigurnosna provjera nije uspjela. Pokušajte ponovno poslati poruku.": "csrf",
  "Previše pokušaja. Pričekajte nekoliko minuta pa pokušajte ponovno.": "rateLimit",
  "Poruka nije prihvaćena. Pokušajte ponovno.": "rejected",
  "Sadržaj upita je promijenjen. Pokušajte ponovno.": "changed",
  "Upit je već u obradi. Pokušajte ponovno.": "processing",
  "Upit je već u obradi. Pričekajte pa pokušajte ponovno.": "processing",
  "Upit nije pronađen.": "notFound",
  "Poruka sadrži nedopušten sadržaj. Izmijenite tekst upita.": "blocked",
  "Slanje e-maila nije potvrđeno. Unos je sačuvan; pokušajte ponovno ili nas kontaktirajte izravno.": "emailFailed",
};

export class ContactRequestError extends Error {
  constructor(key) {
    super(key);
    this.messageKey = `contact.errors.${key}`;
  }
}

export function contactErrorKey(status, detail) {
  if (typeof detail === "string" && detailKeys[detail]) return detailKeys[detail];
  return ({ 400: "validation", 401: "sessionExpired", 403: "forbidden", 404: "notFound", 409: "processing", 422: "validation", 429: "rateLimit", 502: "emailFailed" })[status] || "unavailable";
}